import { render, staticRenderFns } from "./buku_penyaluran.vue?vue&type=template&id=394136cf&"
import script from "./buku_penyaluran.vue?vue&type=script&lang=js&"
export * from "./buku_penyaluran.vue?vue&type=script&lang=js&"
import style0 from "./buku_penyaluran.vue?vue&type=style&index=0&id=394136cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports